import React from 'react'
import _ from 'underscore'
import PropTypes from 'prop-types'
import ImmutablePropTypes from 'react-immutable-proptypes'
import FlywheelStats from './flywheel/flywheelstats'
import CloudwaysStats from './cloudways/cloudwaysstats'
import WPEngineStats from './wpengine/wpenginestats'
import WPCOMStats from './wpcom/wpcomstats'
import MgStats from './mg/mgstats'

class Stats extends React.Component {
	constructor(props) {
		super(props)
		this.state = {progress: 0}
		this.progressMessage = this.progressMessage.bind(this)
	}
	componentDidMount() {
		this.calculateProgress()
	}
	componentDidUpdate(prevProps) {
		const { task } = this.props
		const prevTask = prevProps.task
		if (!prevTask.equals(task)) {
			this.calculateProgress()
		}
	}
	calculateProgress() {
		const { task } = this.props
		let progress
		let restore = task.get('restore').first()
		let steps = BLOGTASKSTEPCHAIN[BLOGTASKSTEPTYPE.RESTORE]
		let currentStep = steps.findIndex((step) => (step.id === restore.getIn(['progress', 'step'])))
		if (currentStep < 0) {
			progress = 0
		} else {
			let stepIndex = currentStep === 0 ? currentStep : currentStep + 1
			progress = steps.slice(0, stepIndex).reduce((p, step) => (p + step['weightage']), 0)
		}
		this.setState({ progress: progress })
	}
	progressMessage() {
		const { task } = this.props
		let restore = task.get('restore').first()
		let message = _.isEmpty(restore.getIn(['progress', 'message'])) ? "" : restore.getIn(['progress', 'message'])
		if (restore.getIn(['progress', 'num'])) {
			message += ` ${restore.getIn(['progress', 'num'])} / ${restore.getIn(['progress', 'den'])}`
		}
		return message
	}
	render() {
		const { task, canUpsell, cancel } = this.props
		const { progress } = this.state
		let migrate = task.get('migrate').first()
		switch (migrate.get('origin')) {
		case ORIGIN.FLYWHEEL:
			return <FlywheelStats migrate={migrate} cancel={cancel} progress={progress}/>
		case ORIGIN.CLOUDWAYS:
			return <CloudwaysStats migrate={migrate} cancel={cancel} progress={progress}/>
		case ORIGIN.WPENGINE:
			return <WPEngineStats migrate={migrate} cancel={cancel} progress={progress}/>
		case ORIGIN.AUTOMATTIC:
			return <WPCOMStats migrate={migrate} cancel={cancel} progress={progress}/>
		default:
			return <MgStats canUpsell={canUpsell} migrate={migrate} progress={progress} progressMessage={this.progressMessage}/>
		}
	}
}

Stats.propTypes = {
	task: ImmutablePropTypes.map,
	canUpsell: PropTypes.bool,
	cancel: PropTypes.func
}

export default Stats
